import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { guestGuard } from './guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [guestGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./components/public/home/home.component').then(m => m.HomeComponent)
      },
      { path: 'home', redirectTo: '', pathMatch: 'full' },
      { 
        path: 'login', 
        loadComponent: () => import('./components/auth/login/login.component').then(m => m.LoginComponent)
      },
      { 
        path: 'register', 
        loadComponent: () => import('./components/auth/register/register.component').then(m => m.RegisterComponent)
      },
      { 
        path: 'forgot-password', 
        loadComponent: () => import('./components/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
      }
    ]
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    children: [
      { 
        path: 'student', 
        loadComponent: () => import('./components/dashboard/student/student.component').then(m => m.StudentComponent)
      },
      { 
        path: 'admin', 
        loadComponent: () => import('./components/dashboard/admin/admin.component').then(m => m.AdminComponent)
      },
      { 
        path: 'admin/users', 
        loadComponent: () => import('./components/dashboard/admin-users/admin-users.component').then(m => m.AdminUsersComponent)
      },
      { path: '', redirectTo: 'student', pathMatch: 'full' }
    ]
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./components/profile/profile.component').then(m => m.ProfileComponent)
  },
  {
    path: 'subscribe',
    canActivate: [authGuard],
    loadComponent: () => import('./components/subscribe/subscribe.component').then(m => m.SubscribeComponent)
  },
  { path: '**', redirectTo: '' }
];